
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Trash2 } from 'lucide-react';
import { OtherDocument } from './types';

interface OtherDocumentsUploadProps {
  documents: OtherDocument[];
  maxDocuments: number;
  onUpload: (file: File) => void;
  onRemove: (index: number) => void;
}

export function OtherDocumentsUpload({
  documents,
  maxDocuments,
  onUpload,
  onRemove,
}: OtherDocumentsUploadProps) {
  const [selectedFileName, setSelectedFileName] = useState<string>('');

  return (
    <div className="space-y-2">
      <Label htmlFor="other_documents">Other Documents</Label>
      <div className="space-y-4">
        {documents.map((doc, index) => (
          <div key={index} className="flex items-center justify-between gap-2 p-2 bg-gray-50 rounded">
            <a
              href={doc.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-blue-600 hover:underline flex-1 truncate"
            >
              {doc.name}
            </a>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onRemove(index)}
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        ))}
        {documents.length < maxDocuments && (
          <Input
            id="other_documents"
            type="file"
            accept=".pdf,.doc,.docx,.xlsx,.csv"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) {
                setSelectedFileName(file.name);
                onUpload(file);
              }
            }}
            className="cursor-pointer"
          />
        )}
        <p className="text-sm text-muted-foreground">
          Upload up to {maxDocuments} additional documents (.pdf, .doc, .docx, .xlsx, .csv)
        </p>
      </div>
    </div>
  );
}
